module.exports = __webpack_public_path__ + "static/media/templateRatingImberaMX.cdee29c0.xlsx";